var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames);
    global.SearchMenu = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _classnames) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var SearchMenu = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(SearchMenu, _PureComponent);

    var _super = _createSuper(SearchMenu);

    function SearchMenu() {
      var _this;

      (0, _classCallCheck2.default)(this, SearchMenu);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchToggle", function (event) {
        _this.props.onSearchToggle(event);
      });
      return _this;
    }

    (0, _createClass2.default)(SearchMenu, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            className = _this$props.className,
            isLink = _this$props.isLink,
            searchIsOpen = _this$props.searchIsOpen,
            links = _this$props.links;
        var search = links[0];
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('next-menu__list', className)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "next-menu__item"
        }, isLink ? /*#__PURE__*/_react.default.createElement("a", {
          className: (0, _classnames.default)('next-menu__link', search.attr ? search.attr.class : ''),
          href: search.href,
          title: search.attr ? search.attr.title : ''
        }, search.label) : /*#__PURE__*/_react.default.createElement("button", {
          "aria-expanded": searchIsOpen,
          type: "button",
          className: (0, _classnames.default)('next-menu__link', search.attr ? search.attr.class : ''),
          title: search.attr ? search.attr.title : '',
          onClick: this.onSearchToggle
        }, search.label)));
      }
    }]);
    return SearchMenu;
  }(_react.PureComponent);

  var linkPropType = _propTypes.default.shape({
    label: _propTypes.default.string,
    href: _propTypes.default.string
  });

  SearchMenu.propTypes = {
    className: _propTypes.default.string,
    isLink: _propTypes.default.bool,
    searchIsOpen: _propTypes.default.bool,
    links: _propTypes.default.arrayOf(linkPropType),
    onSearchToggle: _propTypes.default.func
  };
  SearchMenu.defaultProps = {
    className: '',
    isLink: true,
    searchIsOpen: false,
    links: []
  };
  var _default = SearchMenu;
  _exports.default = _default;
});